import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { classHelper } from "../../utils/stringUtils";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ReactPlayer from "react-player";
import Image from "../UI/Image";
import "./MediaViewer.scss";

const MediaViewer = ({ ENV_NAME, show, onHide, medias, thumbs, idx, className, ...props }) => {
	const [tempIdx, setTempIdx] = useState(0);

	useEffect(() => {
		if (show) {
			setTempIdx(idx ? idx : 0);
		} else {
			setTempIdx(0);
		}
	}, [show, idx]);

	return (
		<Modal
			show={show}
			onHide={onHide}
			dialogClassName={classHelper("media-viewer-modal", className || "")}
			size="lg"
			centered
		>
			<Modal.Body>
				<Carousel
					showStatus={false}
					dynamicHeight
					selectedItem={tempIdx}
					thumbWidth={105}
					onChange={(index, _) => setTempIdx(index)}
					renderThumbs={() => thumbs?.map((i) => <Image className="thumbnail" key={idx} src={i} />)}
					showIndicators={false}
				>
					{medias?.map((i, idx) =>
						i?.type === "video" ? (
							<div className="flex-all-center" key={idx}>
								<ReactPlayer width="100%" controls url={i?.url} />
							</div>
						) : (
							<img className="img-viewer" key={idx} src={i?.url || i} alt="medias" />
						)
					)}
				</Carousel>
			</Modal.Body>
		</Modal>
	);
};

export default MediaViewer;
